import { render } from "./HeaderBg.vue?vue&type=template&id=30516e59"
import script from "./HeaderBg.vue?vue&type=script&lang=js"
export * from "./HeaderBg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__